import { useState } from "react";
import { Button, Col, Modal, Row } from "react-bootstrap";
import { AvField, AvForm } from "availity-reactstrap-validation";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import Select from "react-select";
import { Translate } from "../../../Enums/Tranlate";
import NotificationService from "../../../../services/NotificationService";
import EmployeesService from "../../../../services/HRM/EmployeesService";
import ScrollPagination from "../../../common/ScrollPagination";

const typeOptions = [
	{ label: "Announcement", value: "announcement" },
	{ label: "General", value: "general" },
	{ label: "Warning", value: "warning" },
	{ label: "System", value: "system" },
];

const AddNotificationModal = ({ addModal, setAddModal, setShouldUpdate }) => {
	const [formData, setFormData] = useState({
		massageTitleEn: "",
		massageTitleAr: "",
		massageBodyEn: "",
		massageBodyAr: "",
		type: null,
		employeeIds: [],
	});
	const [loading, setLoading] = useState(false);
	const lang = useSelector((state) => state.auth?.lang);

	const submit = (e) => {
		e.preventDefault();
		const data = {
			massageTitleEn: formData.massageTitleEn,
			massageTitleAr: formData.massageTitleAr,
			massageBodyEn: formData.massageBodyEn,
			massageBodyAr: formData.massageBodyAr,
			type: formData.type?.value,
			employeeIds: formData.employeeIds.map((e) => e.value || e.id),
		};
		setLoading(true);
		new NotificationService()
			.send(data)
			.then((res) => {
				if (res?.status === 200 || res?.status === 201) {
					toast.success(Translate[lang]?.sent_successfully || "Sent Successfully");
					setShouldUpdate((prev) => !prev);
					setAddModal();
				}
			})
			.finally(() => setLoading(false));
	};

	return (
		<Modal
			className={lang === "en" ? "en fade addProduct" : "ar fade addProduct"}
			style={{ textAlign: lang === "en" ? "left" : "right" }}
			show={addModal}
			onHide={setAddModal}>
			<AvForm className="form-horizontal" onValidSubmit={submit}>
				<Modal.Header>
					<Modal.Title>{Translate[lang]?.send} {Translate[lang]?.notification}</Modal.Title>
					<Button
						variant=""
						className="close"
						style={{
							right: lang === "en" ? "0" : "auto",
							left: lang === "ar" ? "0" : "auto",
						}}
						onClick={setAddModal}>
						<span>&times;</span>
					</Button>
				</Modal.Header>
				<Modal.Body>
					<Row>
						<Col md={6}>
							<AvField
								label={Translate[lang]?.message_title_en || "Title (EN)"}
								type="text"
								placeholder={Translate[lang]?.message_title_en || "Title (EN)"}
								bsSize="lg"
								name="massageTitleEn"
								validate={{
									required: { value: true, errorMessage: Translate[lang]?.field_required },
								}}
								value={formData.massageTitleEn}
								onChange={(e) =>
									setFormData({ ...formData, massageTitleEn: e.target.value })
								}
							/>
						</Col>
						<Col md={6}>
							<AvField
								label={Translate[lang]?.message_title_ar || "Title (AR)"}
								type="text"
								placeholder={Translate[lang]?.message_title_ar || "Title (AR)"}
								bsSize="lg"
								name="massageTitleAr"
								validate={{
									required: { value: true, errorMessage: Translate[lang]?.field_required },
								}}
								value={formData.massageTitleAr}
								onChange={(e) =>
									setFormData({ ...formData, massageTitleAr: e.target.value })
								}
							/>
						</Col>
						<Col md={6}>
							<AvField
								label={Translate[lang]?.message_body_en || "Body (EN)"}
								type="textarea"
								placeholder={Translate[lang]?.message_body_en || "Body (EN)"}
								bsSize="lg"
								name="massageBodyEn"
								validate={{
									required: { value: true, errorMessage: Translate[lang]?.field_required },
								}}
								value={formData.massageBodyEn}
								onChange={(e) =>
									setFormData({ ...formData, massageBodyEn: e.target.value })
								}
							/>
						</Col>
						<Col md={6}>
							<AvField
								label={Translate[lang]?.message_body_ar || "Body (AR)"}
								type="textarea"
								placeholder={Translate[lang]?.message_body_ar || "Body (AR)"}
								bsSize="lg"
								name="massageBodyAr"
								validate={{
									required: { value: true, errorMessage: Translate[lang]?.field_required },
								}}
								value={formData.massageBodyAr}
								onChange={(e) =>
									setFormData({ ...formData, massageBodyAr: e.target.value })
								}
							/>
						</Col>
						<Col md={12} className="mb-3">
							<label className="text-label">{Translate[lang]?.type}</label>
							<Select
								placeholder={Translate[lang]?.select}
								options={typeOptions}
								value={formData.type}
								onChange={(e) => setFormData({ ...formData, type: e })}
							/>
						</Col>
						<Col md={12} className="mb-3">
							<label className="text-label">{Translate[lang]?.employees}</label>
							<ScrollPagination
								isMulti
								Service={new EmployeesService()}
								value={formData.employeeIds}
								nameVal="name"
								setData={(e) => setFormData({ ...formData, employeeIds: e || [] })}
							/>
						</Col>
					</Row>
				</Modal.Body>
				<Modal.Footer>
					<Button onClick={setAddModal} variant="danger light">
						{Translate[lang]?.close}
					</Button>
					<Button variant="primary" type="submit" disabled={loading}>
						{loading ? (
							<span className="spinner-border spinner-border-sm" />
						) : (
							Translate[lang]?.send
						)}
					</Button>
				</Modal.Footer>
			</AvForm>
		</Modal>
	);
};

export default AddNotificationModal;
